export * from './common-urls';
export * from './colors';
export * from './privileges';

export const Breakpoints = {
    Sm: 600,
    Md: 900,
    Lg: 1160,
    Xl: 1760,
};
